var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.534,
    height: 22.526,
    viewBox: "0 0 22.534 22.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_x2F_icon-24_x2F_networks_x2F_binance_x5F_smart_x5F_chain",
    transform: "translate(-242.7 -142.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M258.348,155.562,260.9,158.1l-6.93,6.923-6.923-6.923,2.549-2.542,4.373,4.373Zm-4.381-4.381,2.586,2.586h0l-2.586,2.586-2.579-2.579v-.007h0l.454-.454.22-.22Zm-8.718.037,2.549,2.549-2.549,2.542L242.7,153.76Zm17.435,0,2.549,2.549-2.549,2.542-2.549-2.549Zm-8.718-8.718,6.923,6.923-2.549,2.549-4.373-4.381-4.373,4.373-2.549-2.542Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.538567276ab9e8b3d3b69f4322c9a32d.svg";
export { ForwardRef as ReactComponent };